import { Dialog } from '@headlessui/react';
import { Fragment } from 'react';
import styled from 'styled-components';

const Backdrop = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Panel = styled(Dialog.Panel)`
    background: #fff;
    border-radius: 8px;
    padding: 24px;
    max-width: 478px;
    width: 100%;
    z-index: 1000;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
`;

const Title = styled(Dialog.Title)`
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 16px;
`;

const ModalContainer = ({ isOpen, onClose, title, children }) => {
    return (
        <Dialog open={isOpen} onClose={onClose} as={Fragment}>
            <Backdrop>
                <Panel>
                    {title && <Title>{title}</Title>}
                    {children}
                </Panel>
            </Backdrop>
        </Dialog>
    );
};

export default ModalContainer;
